var _defs, _circle, _path, _ellipse, _ellipse2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmiley33Percent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 395 395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fa0;}.cls-2{fill:#ff9100;}.cls-3{fill:#515151;}.cls-4{fill:none;stroke:#515151;stroke-miterlimit:10;stroke-width:15px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 197.5,
    cy: 197.5,
    r: 192.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.29,11.93a187.55,187.55,0,0,1,73,360.27,187.55,187.55,0,0,1-146-345.54,186.42,186.42,0,0,1,73-14.73m0-10C91.22,1.93,2.79,90.36,2.79,199.43s88.43,197.5,197.5,197.5,197.5-88.42,197.5-197.5S309.37,1.93,200.29,1.93Z",
    transform: "translate(-2.79 -1.93)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 110.46,
    cy: 162.64,
    rx: 37.03,
    ry: 33.58,
    transform: "translate(-83.51 206.57) rotate(-69.31)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 281.3,
    cy: 162.64,
    rx: 33.58,
    ry: 37.03,
    transform: "translate(-44.9 129.28) rotate(-24.49)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.31,267.57s75-48.53,151.08,0",
    transform: "translate(-2.79 -1.93)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley33Percent);
export default __webpack_public_path__ + "static/media/smiley-33-percent.db9c12bd87ba075057c67c661e2cdfa8.svg";
export { ForwardRef as ReactComponent };